module.exports = __webpack_public_path__ + "static/media/logotipo.7da0fb28.png";